module.exports = __webpack_public_path__ + "static/media/inventory-icon--white.f38fc4b1.svg";